import {
  getAllBrigadeWorks,
  getOneBrigadeWorks,
  createBrigadeWorks,
  updatePatchBrigadeWorks,
  updatePutBrigadeWorks,
  deleteBrigadeWorks,
  deleteWorks,

  getAllBrigadeWorkCategories,
  getOneBrigadeWorkCategories,
  createBrigadeWorkCategories,
  updatePatchBrigadeWorkCategories,
  updatePutBrigadeWorkCategories,
  deleteWorkCategories,
  deleteBrigadeWorkCategories,
} from '@/api/reference'

export default {
  CREATE_BRIGADE_WORKS(_, data) {
    return createBrigadeWorks(data)
  },
  FETCH_ALL_BRIGADE_WORKS({ commit }, params) {
    return getAllBrigadeWorks(params)
      .then(res => {
        commit('SET_ALL_BRIGADE_WORKS', res.data)
      })
  },
  FETCH_ONE_BRIGADE_WORKS({ commit }, params) {
    return getOneBrigadeWorks(params)
      .then(res => {
        commit('SET_ONE_BRIGADE_WORKS', res.data)
      })
  },
  UPDATE_PATCH_BRIGADE_WORKS(_, data) {
    return updatePatchBrigadeWorks(data)
  },
  UPDATE_PUT_BRIGADE_WORKS(_, data) {
    return updatePutBrigadeWorks(data)
  },
  DELETE_WORKS(_, id) {
    return deleteWorks(id)
  },
  DELETE_BRIGADE_WORKS(_, data) {
    return deleteBrigadeWorks(data)
  },

  










  CREATE_BRIGADE_WORK_CATEGORIES(_, data) {
    return createBrigadeWorkCategories(data)
  },
  FETCH_ALL_BRIGADE_WORK_CATEGORIES({ commit }, params) {
    return getAllBrigadeWorkCategories(params)
      .then(res => {
        commit('SET_ALL_BRIGADE_WORK_CATEGORIES', res.data)
      })
  },
  FETCH_ONE_BRIGADE_WORK_CATEGORIES({ commit }, params) {
    return getOneBrigadeWorkCategories(params)
      .then(res => {
        commit('SET_ONE_BRIGADE_WORK_CATEGORIES', res.data)
      })
  },
  UPDATE_PATCH_BRIGADE_WORK_CATEGORIES(_, data) {
    return updatePatchBrigadeWorkCategories(data)
  },
  UPDATE_PUT_BRIGADE_WORK_CATEGORIES(_, data) {
    return updatePutBrigadeWorkCategories(data)
  },
  DELETE_WORK_CATEGORIES(_, id) {
    return deleteWorkCategories(id)
  },
  DELETE_BRIGADE_WORK_CATEGORIES(_, data) {
    return deleteBrigadeWorkCategories(data)
  },
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  // CREATE_BRIGADE_WORKS(_, data) {
  //   return createBrigadeWorks(data)
  // },
  FETCH_PRODUCT_LIST({ commit }, params) {
    return getAllBrigadeWorks(params)
      .then(res => {
        commit('SET_ALL_BRIGADE_WORKS', res.data)
      })
  },
  // FETCH_ONE_BRIGADE_WORKS({ commit }, params) {
  //   return getOneBrigadeWorks(params)
  //     .then(res => {
  //       commit('SET_ONE_BRIGADE_WORKS', res.data)
  //     })
  // },
  // UPDATE_PATCH_BRIGADE_WORKS(_, data) {
  //   return updatePatchBrigadeWorks(data)
  // },
  // UPDATE_PUT_BRIGADE_WORKS(_, data) {
  //   return updatePutBrigadeWorks(data)
  // },
  // DELETE_WORKS(_, id) {
  //   return deleteWorks(id)
  // },
  // DELETE_BRIGADE_WORKS(_, data) {
  //   return deleteBrigadeWorks(data)
  // },
}
